import RootRouter from "./ui/RootRouter";
import {FluentProvider, webLightTheme} from "@fluentui/react-components";

export default function App() {
    return <>
        <FluentProvider theme={webLightTheme}>
            <RootRouter />
        </FluentProvider>
    </>
}